module.exports = __webpack_public_path__ + "img/6.b67033d4.png";